import { Action, createReducer, on } from '@ngrx/store';

import { GlobalAppAction } from '../actions';
import { GlobalAppState } from '../states/app.state';

import dayjs from 'dayjs';

const initialState: GlobalAppState = {
  ready: false,
  timestamp: '',
};

const appReducer = createReducer(
  initialState,
  on(GlobalAppAction.SetStart, (state) => ({
    ...state,
    ready: true,
    timestamp: dayjs().format(),
  }))
);

export function GlobalAppReducer(state: GlobalAppState | undefined, action: Action) {
  return appReducer(state, action);
}
